import Automatika from "./Automatika";
import ScadaV2Panel from "./ScadaV2Panel";
import { tg } from "../telegram";
import { useT } from "../i18n";
import { useApp, type Source } from "../state/app";

// «Телеметрия»: one tab for every telemetry source. G1/G2 are the two
// generators in the per-second SCADA tables (incl. the June 2026 export that
// used to be the «SCADA» tab); «Счётчик» is the per-minute Power Analyzer
// meter with its own 40 metrics. The source and both periods live in the app
// context, so «Главная» and «Отчёты» can open or reuse them.
export default function TelemetryPanel({ hasUnits, hasPa }: { hasUnits: boolean; hasPa: boolean }) {
  const { t } = useT();
  const { source, setSource } = useApp();
  const sources: { k: Source; label: string }[] = [
    ...(hasUnits ? [{ k: "g1" as Source, label: "G1" }, { k: "g2" as Source, label: "G2" }] : []),
    ...(hasPa ? [{ k: "pa" as Source, label: t("telemetry.src_pa") }] : []),
  ];
  const eff: Source = sources.some(s => s.k === source) ? source : (sources[0]?.k ?? "g1");
  return (
    <div>
      <h1>{t("tabs.telemetry")}</h1>
      {sources.length > 1 && (
        <div className="turbine-switcher">
          {sources.map(s => (
            <button key={s.k} className={"turbine-chip" + (eff === s.k ? " active" : "")}
              onClick={() => { tg()?.HapticFeedback?.selectionChanged?.(); setSource(s.k); }}>
              <span className="turbine-chip-name">{s.label}</span>
            </button>
          ))}
        </div>
      )}
      {eff === "pa" ? <Automatika /> : <ScadaV2Panel unit={eff === "g2" ? 2 : 1} />}
    </div>
  );
}
